import React, { Component } from 'react';
import { graphql } from 'react-apollo';

// import EditorMain from './EditorMain';
import CKEditor from './Example';

import { notification, Modal } from 'antd/lib';

import getModeloNota from '../../graphql/querys/editor/getModeloNota';
import updateModeloNota from '../../graphql/mutations/editor/updateModeloNota';
import deleteModeloNota from '../../graphql/mutations/editor/deleteModeloNota';

import getModelosNotas from '../../graphql/querys/editor/getModelosNotas';
import getCategoriasDeUnModelo from '../../graphql/querys/editor/getCategoriasPorModeloNota.graphql';

import { imprimir } from '../common/funciones/imprimir';

import Loading from '../common/Loading';
import { errorService } from '../../graphql/utils/utils';
/*

    CLASE ENCARGADA DE REALIZAR TODAS LAS OPERACIONES NECESARIAS EN LA EDICION DE UN MODELO NOTA.
    LLAMA AL EDITOR PARA PODER OPERAR.

*/

const confirm = Modal.confirm;

class EditarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modelo_nota: {
        id: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
        categorias: [],
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onSubmit(modelo_nota) {
    this.props.mutate({
      variables: { htmlModeloNota: modelo_nota },
    });
  }

  onCancel() {
    //TODO: Agregar un SweetAlert o similar para preguntar si desea volver sin guardar.
    this.props.history.goBack();
  }

  onImprimir = htmlFinal => {
    imprimir(htmlFinal);
  };

  onChange(modelo_nota) {
    //FIXME: Revisar lo siguiente, porque no se puede actualizar el estado, o porque no se actualiza...
    // console.log(this.props);
    // console.log("Entre al on change con..");
    // console.log(modelo_nota);
    // this.setState({
    //     ...this.state,
    //     modelo_nota: {
    //         id: this.props.match.params.id,
    //         titulo: modelo_nota.titulo,
    //         descripcion: modelo_nota.descripcion,
    //         htmlModelo: modelo_nota.htmlModelo
    //     }
    // });
    // console.log(this.state);

    let bandera1 = true,
      bandera2 = true,
      bandera3 = true;

    try {
      var organismos = [];
      modelo_nota.organismos.map(organismo => {
        if (organismo._id) {
          // console.log("entre con...", organismo);
          organismos.push(organismo._id);
        } else {
          organismos.push(organismo);
        }
      });
    } catch (error) {
      bandera1 = false;
      console.log(error);
      notification.error({
        message: 'Error con los organismos',
        description: 'El modelo de nota debe pertenecer a un organismo',
      });
    }

    try {
      var clasificadores = [];
      // console.log("CLASIFICADORES: ");
      // console.log(modelo_nota);
      // console.log(modelo_nota.clasificadoresEstadisticos);
      modelo_nota.clasificadoresEstadisticos.map(clasificador => {
        if (clasificador && clasificador._id) {
          // console.log("entre con...", organismo);
          clasificadores.push(clasificador._id);
        } else {
          if (clasificador) {
            clasificadores.push(clasificador);
          }
        }
      });
    } catch (error) {
      bandera2 = false;
      console.log(error);
      notification.error({
        message: 'Error con los clasificadores estadisticos',
        description:
          'Debe de configurar un clasificador para el modelo de nota',
      });
    }

    try {
      var nuevoTalonarios = [];

      modelo_nota.talonarios.map(par => {
        if (par && par.talonario) {
          // console.log("entre con...", par);
          nuevoTalonarios.push({
            idTalonario: par.talonario._id,
            idOrganismo: par.organismo._id,
          });
        } else {
          // console.log("ELSEEEE: ");
          nuevoTalonarios.push(par.talonario);
        }
      });
    } catch (error) {
      bandera3 = false;
      console.log(error);
      notification.error({
        message: 'Error con el talonario',
        description: 'Debe de configurar un talonario para el modelo de nota',
      });
    }

    if (bandera1 && bandera2 && bandera3) {
      this.props
        .mutate({
          variables: {
            idModeloNota: this.props.match.params.id,
            titulo: modelo_nota.titulo,
            descripcion: modelo_nota.descripcion,
            htmlModeloNota: modelo_nota.htmlModelo,
            talonarios: nuevoTalonarios,
            organismos: organismos,
            clasificadoresEstadisticos: clasificadores,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.props.history.push('/admin/editor/listar');
        });
    }
  }

  onDelete(id) {
    //Metodo encargado de ejecutar el llamado a GraphQL para determinar un modelo con id: id

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este modelo de nota?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.setState({ loading: true });
        yo.props
          .mutate({
            mutation: deleteModeloNota,
            variables: {
              idModeloNota: id,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            // console.log(res);
            yo.setState({ loading: false }, () => {
              yo.props.history.push('/admin/editor/listar');
            });
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el modelo de nota'
            );
            console.log(err);
            errorService(err, {
              idModeloNota: id,
            });
            Modal.error({
              title: 'Error en la eliminacion del modelo de nota',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  componentDidMount() {
    // console.log("Entre al did mount");
    // console.log(this.props);
    // console.log(this.props.match.params.id)
  }

  render() {
    // console.log(this.props)
    if (!this.props.data.getModeloNota) {
      return <Loading />;
    }

    const modelo_nota = this.props.data.getModeloNota;

    return (
      <div>
        <CKEditor
          modelo_nota={modelo_nota}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onChange={this.onChange}
          onDelete={this.onDelete}
          onImprimir={this.onImprimir}
          accion="actualizar"
        />
      </div>
    );
  }
}

export default graphql(updateModeloNota, {
  options: props => ({
    refetchQueries: [
      {
        query: getModelosNotas,
      },
      {
        query: getCategoriasDeUnModelo,
        variables: { idModeloNota: props.match.params.id },
      },
    ],
  }),
})(
  graphql(getModeloNota, {
    options: props => {
      return {
        variables: { id: props.match.params.id },
        fetchPolicy: 'network-only',
      };
    },
  })(EditarContainer)
);
